import { strategyToOptions } from "@/common/utils/strategyToOptions";
import { BranchHierarchyForUserAccess } from "../../types/companyBranches.type";

export const branchHierarchyForUserAccess = {
  [BranchHierarchyForUserAccess.SameOnly]: 'Apenas esta filial',
  [BranchHierarchyForUserAccess.SameAndDescendents]: 'Esta filial e descendentes',
}

export const branchHierarchyForUserAccessOptions = strategyToOptions(branchHierarchyForUserAccess);
